'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var hasPingedNewRelic = false;

var reportMethodCall = function reportMethodCall(methodName) {
  if (window.newrelic && !hasPingedNewRelic) {
    hasPingedNewRelic = true;
    window.newrelic.addPageAction('uicomponentsImmutableRecordMethodUsed', {
      methodName: methodName + '-polyfill'
    });
  }
  _devLogger2.default.warn({
    message: 'SyntheticEvent: Deprecated method "' + methodName + '" was used',
    key: 'syntheticevent-' + methodName,
    url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/5356'
  });
};

var SyntheticEventClass = function () {
  function SyntheticEventClass(value, evt) {
    _classCallCheck(this, SyntheticEventClass);

    var target = {
      value: value
    };
    this.target = target;
    this.currentTarget = target;
    this.source = evt;
  }

  _createClass(SyntheticEventClass, [{
    key: 'preventDefault',
    value: function preventDefault() {
      if (this.source) {
        this.source.preventDefault();
      }
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation() {
      if (this.source) {
        this.source.stopPropagation();
      }
    }
  }, {
    key: 'equals',
    value: function equals(other) {
      // Legacy support for Immutable's "equals"
      reportMethodCall('equals');
      return other.target.value === this.target.value && other.source === this.source;
    }
  }]);

  return SyntheticEventClass;
}();

function SyntheticEvent(value, evt) {
  return new SyntheticEventClass(value, evt);
}

SyntheticEvent.constructor = SyntheticEventClass;

exports.default = SyntheticEvent;
module.exports = exports['default'];